import { render, staticRenderFns } from "./OfficialVisa.vue?vue&type=template&id=6035d287&"
import script from "./OfficialVisa.vue?vue&type=script&lang=js&"
export * from "./OfficialVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports